/* eslint-disable react/jsx-no-bind */
import React from 'react';
import { Store } from 'redux';
import loadable from '@loadable/component';
import { Switch, Redirect, Route } from 'react-router-dom';
import { FACEBOOK_DEPRECATION_PAGE } from '@pegasus/deprecation-overlays';

import CoreLayout from '../layouts/core';
import GuestLayout from '../layouts/guest';
import MyLounge from '../views/mylounge';

import { getIsLoggedIn } from '../redux/modules/customer/selectors';

const LoadableSuccess = loadable(
    () => import(/* webpackChunkName: "success-page-component" */ '../views/success'),
);

const LoadablePrivacyPage = loadable(
    () => import(/* webpackChunkName: "privacy-component" */ '../views/privacy'),
);

const LoadableGenericErrorPage = loadable(
    () => import(/* webpackChunkName: "generic-error-page" */ '../views/genericErrorPage'),
);

const PlusMembershipSignupSuccessPage = loadable(
    () =>
        import(
            /* webpackChunkName: "plus-membership-signup-success" */ '../views/plus-membership/signup-success'
        ),
);

// TODO: fix typing
type ReduxStore = Store<any>;

// params in parenthesis are optional
export default (store: ReduxStore) => {
    const state = store.getState();
    const isLoggedIn = getIsLoggedIn(state);

    const Layout = isLoggedIn ? CoreLayout : GuestLayout;

    return (
        <Switch>
            <Route path={['/event', '/checkout', `/${FACEBOOK_DEPRECATION_PAGE}`]}>
                <CoreLayout>
                    <Route path="/event/:categoryTabId?">
                        <MyLounge />
                    </Route>
                    <Route path="/checkout/success/index/ordernumber/:orderNumber">
                        <LoadableSuccess />
                    </Route>
                    <Route path={`/${FACEBOOK_DEPRECATION_PAGE}`}>
                        <MyLounge />
                    </Route>
                </CoreLayout>
            </Route>

            <Route path="/plus-membership/signup/success">
                <PlusMembershipSignupSuccessPage />
            </Route>

            <Route path={['/privacy', '/error-page']}>
                <Layout>
                    <Route
                        render={() => <LoadablePrivacyPage isGuest={!isLoggedIn} />}
                        path="/privacy"
                    />
                    <Route
                        render={() => <LoadablePrivacyPage isGuest={!isLoggedIn} />}
                        path="/privacy/app"
                    />
                    <Route component={LoadableGenericErrorPage} path="/error-page" />
                </Layout>
            </Route>

            <Redirect to="/event" />
        </Switch>
    );
};
